module.exports = __webpack_public_path__ + "static/app-689cc8f0b9d7114498e6c54b89e2d971.svg";